import  React  from "react";
import "../style/HowToUseCoupons.css";

const steps = [
  {
    step: "01",
    title: "Search Coupons by Store",
    desc: "Browse top brands and find verified coupon codes in the Stores section.",
    icon: "🔍",
  },
  {
    step: "02",
    title: "Select the Best Coupon Code",
    desc: "Choose the best available coupon, deal, or promo offer for maximum savings.",
    icon: "🏷️",
  },
  {
    step: "03",
    title: "Apply Coupon & Shop Online",
    desc: "Copy the coupon code and shop online by visiting the official store website.",
    icon: "🛒",
  },
  {
    step: "04",
    title: "Save Money at Checkout",
    desc: "Paste the coupon code at checkout and enjoy instant discounts on your order.",
    icon: "💰",
  },
];

export default function HowToUseCoupons() {
  return (
    <section className="how-modern">
      <div className="how-container">
        <h2 className="how-title">How to Use Coupons</h2>
        <p className="how-subtitle">
          Save money in just four simple steps
        </p>

        <div className="how-cards">
          {steps.map((item, i) => (
            <div className="how-card" key={i}>
              <div className="how-top">
                <span className="how-step">{item.step}</span>
                <span className="how-icon">{item.icon}</span>
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
